import type { ReactNode } from "react"
import { useMsal } from "@azure/msal-react"
import { InteractionStatus } from "@azure/msal-browser"
import { Navigate, useLocation } from "react-router-dom"
import { buildLoginUrlWithReturnTo } from "@/v2-console-shared/auth/auth.redirect"

type AuthGuardProps = {
  children: ReactNode
}

function AuthGuard(props: AuthGuardProps) {
  const { children } = props
  const { accounts, inProgress } = useMsal()
  const location = useLocation()

  if (inProgress !== InteractionStatus.None) {
    return <>{children}</>
  }

  if (accounts.length === 0) {
    // Carry the current location as the ?r= return path so completing the
    // sign-in lands back on the deep link (e.g. /layers), not the home page
    // (FUS-900). AuthLoginPage resolves it for both the already-signed-in
    // redirect and MSAL's redirectStartPage.
    return <Navigate to={buildLoginUrlWithReturnTo(location)} replace />
  }

  return <>{children}</>
}

export default AuthGuard
